module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAAAAXNSR0IArs4c6QAAAJlJREFUOE9jZKACYASZURJ34D92sxgbehbZNxKyh4AheLT/++/Ys8TxAEgF2Yb8/89woHexgyOKIT2LHMAGkgPgLgEZgjtscBsN0jcIDGFkuNaz0EGbMpcw/W/sWeDYgBKYpIYJM/s/nc7ZTlfBhhTG7rNnYmBqYGRkcCA6dqBeoSidMEC9QpEhP/8yaU9eancNbgjRXsChEAADHVIPorRyRAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/folderP.png
// module id = 418
// module chunks = 0